import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { Form, FormGroup } from "react-bootstrap";
import moment from "moment";

import Button from "../../../../components/common/button/Button";
import DatePicker2 from "../../../../components/common/datepicker/DatePicker2";
import Input from "../../../../components/common/input/Input";
import Select2 from "../../../../components/common/select/Select2";

import {
  required,
  floatWithComma,
  comma,
  date
} from "../../../../utils/forms/validators";
import { formatDateLog } from "../../../../utils/dates";
import { INVOICE_CREATE_FORM } from "./../../../../actions/invoice.actions";

import styles from "./AdminCompanyBillingAdd.scss";

const rateFloat = floatWithComma("Please enter a valid number.");
const rateComma = comma("Please enter numeric characters only");
const dateVal = date("Please enter a valid Date.");

class AdminCompanyBillingAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: moment(),
      invoices: null,
      invoiceOptions: [],
      showQuickbooks: false,
      valid: true
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleProjectSelect = this.handleProjectSelect.bind(this);
    this.handleActiontSelect = this.handleActionSelect.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.projectOptions !== this.props.projectOptions) {
      const projectOptions = this.props.projectOptions;

      if (projectOptions && projectOptions.length === 1) {
        const defaultProject = _.first(projectOptions);
        this.props.change("project_id", defaultProject.id);
        this.handleProjectSelect(defaultProject.id, this.props.projects);
      }
    }
  }

  handleDateChange(date) {
    let newDate = moment(date);

    if (newDate.isValid()) {
      this.setState({ date: moment(newDate) });
    }
  }

  handleProjectSelect(projectId, projects) {
    let options = [];

    const selectedProject = _.first(
      _.filter(projects, {
        id: projectId
      })
    );

    _.forEach(selectedProject.invoices, invoice => {
      const option = {
        id: invoice.id,
        value: `${formatDateLog(invoice.created_at)} | ${invoice.filename}`
      };
      options.push(option);
    });

    this.setState({
      invoiceOptions: options
    });
  }

  handleActionSelect(statusId, options) {
    const selected = _.head(
      _.filter(options, status => {
        return status.id === statusId;
      })
    );

    this.setState({
      showQuickbooks: selected.slug === "sent_bill_to_client"
    });
  }

  render() {
    const {
      projects,
      projectOptions,
      status,
      handleSubmit,
      submitting,
      valid
    } = this.props;

    return (
      <section className={styles.invoice}>
        <div className={styles.content}>
          <h2 className={styles.title}>Add Billing Activity</h2>

          <Form onSubmit={handleSubmit}>
            <div className={styles.form}>
              <div className={styles.sectionTitle}>Project</div>
              <FormGroup>
                <Field
                  name="project_id"
                  type="select"
                  placeholder="Select Project"
                  component={Select2}
                  options={projectOptions}
                  onSelectChange={selected =>
                    this.setState({ invoiceOptions: [] }, () =>
                      this.handleProjectSelect(selected, projects)
                    )
                  }
                  validate={required}
                />
              </FormGroup>

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Invoice</div>
              <FormGroup>
                <Field
                  name="invoice_id"
                  type="select"
                  placeholder="Select Invoice"
                  component={Select2}
                  options={this.state.invoiceOptions}
                  validate={required}
                />
              </FormGroup>

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Date of Activity</div>

              <FormGroup>
                <Field
                  name="created_at"
                  placeholder="Select Date"
                  component={DatePicker2}
                  maxDate={moment()}
                  onSelectDate={this.handleDateChange}
                  validate={[required, dateVal]}
                />
              </FormGroup>

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Action</div>
              <FormGroup>
                <Field
                  name="status_id"
                  type="select"
                  placeholder="Select Action"
                  component={Select2}
                  options={status}
                  onSelectChange={selected => {
                    this.handleActionSelect(selected, status);
                  }}
                  validate={required}
                />
              </FormGroup>

              {this.state.showQuickbooks && (
                <React.Fragment>
                  <div className={styles.divider} />
                  <div className={styles.sectionTitle}>Quickbooks</div>
                  <FormGroup>
                    <Field
                      name="quickbooks_id"
                      type="text"
                      placeholder="Quickbooks ID"
                      component={Input}
                    />
                  </FormGroup>
                </React.Fragment>
              )}

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Amount</div>

              <FormGroup>
                <Field
                  name="amount"
                  type="text"
                  placeholder="Amount"
                  component={Input}
                  onChange={this.handleRateChange}
                  validate={[rateFloat, rateComma]}
                />
              </FormGroup>

              <div className={styles.CTAContainer}>
                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  noMarginBottom
                  label="Submit Activity"
                  isDisabled={!valid || submitting}
                />
              </div>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

AdminCompanyBillingAdd = reduxForm({
  form: INVOICE_CREATE_FORM,
  enableReinitialize: true
})(AdminCompanyBillingAdd);

export default AdminCompanyBillingAdd;



// WEBPACK FOOTER //
// ./src/routes/admin/company/components/AdminCompanyBillingAdd.js